import IQueryTradesBasicInfo from 'src/services/interfaces/IQueryTradesBasicInfo';
import * as React from 'react';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { useState, useContext } from 'react';
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

export function ButtonExport(props: { request: IQueryTradesBasicInfo }) {
    const { reportService } = useContext(ServiceContext);

    const [loading, setLoading] = useState<boolean>(false);

    async function exportTrades() {
        setLoading(true);
        reportService
            .exportTrades(props.request)
            .then(res => ShowNotification.Success("Sucesso!", "Download Efetuado!"))
            .catch(error => ShowNotification.Error("Falha ao realizar o download", "Falha ao realizar o download, por favor entre em contato com o time de tecnologia."))
            .finally(() => setLoading(false));
    }
    return (
        <Tooltip title="Exportar">
            <button disabled={loading} className="view-trade-phase btn" onClick={() => exportTrades()}>
                <FontAwesomeIcon icon={faFileExcel} />
            </button>
        </Tooltip>
    );
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/Export/ExportButton.tsx